import { Spinner } from '@drdropin-tech/theseus';

const IS_TEST = process.env.NODE_ENV === 'test';

const SpinnerWrapper = ({ testId }: { testId?: string }) => (
  <div
    className="flex justify-center"
    {...(IS_TEST && testId
      ? {
          'data-testid': testId,
        }
      : {})}
  >
    <Spinner size="xl" />
  </div>
);

export default SpinnerWrapper;
